import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Xicon, approveIcon } from "./Images"
import { useDispatch } from "react-redux";
import { fetchData } from "../redux/apiSlice";
import { toastify, userlogout } from "../redux/controller";
import YouTubePlayer from '../Components/YoutubePlayer';
import mapboxgl from "mapbox-gl";
import MapboxDraw from "@mapbox/mapbox-gl-draw";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX

export default function PropertyDetails() {
  const approve_navigate = useNavigate();
  const [rejectstatus, setRejectstatus] = useState(false);
  const [approveStatus, setApproveStatus] = useState(false);
  const [emptyState, setEmptyState] = useState(false);
  const navigate = useNavigate();
  const [propertyG, setPropertyData] = useState();
  const [propertyId, setPropertyId] = useState('');
  const [propertyName, setPropertyName] = useState('');
  const [propertyCategory, setPropertyCategory] = useState('');
  const [propertyState, setPropertyState] = useState('');
  const [propertyCounty, setPropertyCounty] = useState('');
  const [propertyCity, setPropertyCity] = useState('');
  const [propertyZipCode, setPropertyZipCode] = useState('');
  const [propertyTotalArea, setPropertyTotalArea] = useState('');
  const [propertyAction, setPropertyAction] = useState('');
  const [propertyLandownerId, setPropertyLandownerId] = useState('');
  const [step1inputField, setstep1InputField] = useState({
    cancelreason: ""
  })
  const location = useLocation();
  const { state } = location;
  const { selectedid, id, property_name, category, stateLocal, county, city, zipcode, totalarea, property, action, landownerId } = state || {};
  const [status, setStatus] = useState('Loading...');
  const dispatch = useDispatch();
  const usertoken = localStorage.getItem('usertoken');


  useEffect(() => {
    if (property) {
      // Set default values for privateDate and isPrivateEnable if they don't exist
      if (property.area) {
        const today = new Date().toISOString().split('T')[0];
        const updatedArea = property.area.map(area => {
          return {
            ...area,
            isAreaUnit: 'slotsdetails',
            slots: area.slots ? area.slots.map(slot => ({
              ...slot,
              privateDate: slot.privateDate || today,
              isPrivateEnable: slot.isPrivateEnable || false
            })) : []
          };
        });

        setPropertyData({
          ...property,
          area: updatedArea
        });
      } else {
        setPropertyData(property);
      }

      setPropertyId(id)
      setPropertyName(property_name)
      setPropertyCategory(category)
      setPropertyState(stateLocal)
      setPropertyCounty(county)
      setPropertyCity(city)
      setPropertyZipCode(zipcode)
      setPropertyTotalArea(totalarea)
      setPropertyAction(action)
      setPropertyLandownerId(landownerId)
    } else {
      if (selectedid) {
        setPropertyId(selectedid)
        getPropertyDetails()
      } else {
        navigate('/')
      }
    }
  }, []);

  const getPropertyDetails = async () => {
    setStatus('Loading...')
    const property = await dispatch(
      fetchData({
        apiurl: "/property/listAllproperty",
        propertyid: selectedid ?? propertyId,
        headers: { "x-access-token": usertoken }
      })
    );

    if (property && property.payload && property.payload.status === 200) {
      setStatus('')
      var propertLocal = property.payload.data.property;

      if (propertLocal.area) {
        const today = new Date().toISOString().split('T')[0];
        const updatedArea = propertLocal.area.map(area => {
          return {
            ...area,
            isAreaUnit: 'slotsdetails',
            slots: area.slots ? area.slots.map(slot => ({
              ...slot,
              privateDate: slot.privateDate || today,
              isPrivateEnable: slot.isPrivateEnable || false
            })) : []
          };
        });

        propertLocal = {
          ...propertLocal,
          area: updatedArea
        };
      }

      setPropertyData(propertLocal)
      setPropertyId(property.payload.data.property._id)
      setPropertyName(property.payload.data.property.title)
      setPropertyCategory(property.payload.data.property.category)
      setPropertyState(property.payload.data.property.state)
      setPropertyCounty(property.payload.data.property.county)
      setPropertyCity(property.payload.data.property.city)
      setPropertyZipCode(property.payload.data.property.zipcode)
      setPropertyTotalArea(property.payload.data.property.totalarea)
      setPropertyAction(property.payload.data.property.approved == null ? 'Pending' : property.payload.data.property.approved === "false" ? 'Rejected' : 'Approved')
      setPropertyLandownerId(property.payload.data.landownername._id)
    } else {
      if (property.payload.response && property.payload.response.data && property.payload.response.data.message) {
        if (property.payload.response.data.message === "Invalid token provided!" || property.payload.response.data.message === "No token provided!") {
          userlogout();
          navigate('/');
        }
      }
    }
  }

  function setActiveTab(index, name) {
    const updatedAreas = [...propertyG.area];
    updatedAreas[index] = {
      ...updatedAreas[index],
      isAreaUnit: name
    };

    setPropertyData(prev => ({
      ...prev,
      area: updatedAreas
    }));
  }

  function handlepopupclose() {
    setRejectstatus(false);
    setApproveStatus(false);
  }

  function handleReject() {
    setRejectstatus(true);
  }

  function handleApprove() {
    setApproveStatus(true);
  }

  const handleSlotsSave = async (slots, areaId, propertyId) => {

    var response = await dispatch(
      fetchData({
        apiurl: "/property/updateprivateproperty",
        areaId: areaId,
        slots: slots,
        propertyId: propertyId,
        headers: { "x-access-token": usertoken }
      })
    );
    if(response && response.payload && response.payload.status === 200){
      toastify({ message: 'Slots updated successfully' });
    }
  }

  function convertdate(date) {
    return date.substring(5, 7) + "/" + date.substring(8, 10) + "/" + date.substring(0, 4)
  }

  const handleApproveProperty = async () => {
    var response = await dispatch(
      fetchData({
        apiurl: "/property/approverejectproperty",
        page: 1,
        limit: 100,
        _id: propertyId,
        status: "true",
        propertyName: propertyName,
        selectedid: propertyId,
        landownerId: propertyLandownerId,
        headers: { "x-access-token": usertoken }
      })
    );

    setApproveStatus(false);
    if (response.payload.status === 200) {
      toastify({ "message": 'Property approved successfully' })
      approve_navigate("/properties");
    } else {
      toastify({ message: response.payload.message });
    }
  };

  const handleRejectProperty = async () => {
    var response = await dispatch(
      fetchData({
        apiurl: "/property/approverejectproperty",
        page: 1,
        limit: 100,
        _id: propertyId,
        status: "false",
        landownerId: propertyLandownerId,
        propertyName: propertyName,
        reason: step1inputField.cancelreason,
        selectedid: propertyId,
        headers: { "x-access-token": usertoken }
      })
    );
    setRejectstatus(false);
    if (response.payload.status === 200) {
      toastify({ "message": 'Property rejected successfully' })
      approve_navigate("/properties");
    } else {
      toastify({ message: response.payload.message });
    }
  };

  // Utility function to extract video ID from a YouTube URL
  const getYouTubeVideoId = (url) => {
    try {
      const urlObj = new URL(url);
      return urlObj.searchParams.get('v');
    } catch (e) {
      return null
    }
  };

  const inputsHandler = (e) => {
    setstep1InputField((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value
    }));
  };

  const AreaMap = ({ areaIndex }) => {
    const mapRef = useRef(null);

    useEffect(() => {
      if (!mapRef.current || !propertyG) return;

      const area = propertyG.area[areaIndex];
      const map = new mapboxgl.Map({
        container: mapRef.current,
        style: "mapbox://styles/mapbox/satellite-streets-v12",
        center: [propertyG.latlng?.lng || 0, propertyG.latlng?.lat || 0],
        zoom: parseFloat(propertyG.zoomlevel ?? 10),
      });

      map.on("load", () => {
        if (propertyG.geodraw) {
          map.addSource("main-polygon", {
            type: "geojson",
            data: {
              type: "Feature",
              geometry: {
                type: "Polygon",
                coordinates: propertyG.geodraw.coords.paths,
              },
            },
          });

          map.addLayer({
            id: "main-outline",
            type: "line",
            source: "main-polygon",
            paint: {
              "line-color": propertyG.propertycolor,
              "line-width": 3,
            },
          });

          area.slots.forEach((slot, y) => {
            map.addSource(`slot-${areaIndex}-${y}`, {
              type: "geojson",
              data: {
                type: "Feature",
                geometry: {
                  type: "Polygon",
                  coordinates: slot.coords.paths,
                },
              },
            });

            map.addLayer({
              id: `outline-${areaIndex}-${y}`,
              type: "line",
              source: `slot-${areaIndex}-${y}`,
              paint: {
                "line-color": area.areacolor,
                "line-width": 3,
              },
            });

            map.addSource(`slot-text-${areaIndex}-${y}`, {
              type: "geojson",
              data: {
                type: "FeatureCollection",
                features: [{
                  type: "Feature",
                  geometry: {
                    type: "Polygon",
                    coordinates: slot.coords.paths,
                  },
                  properties: { title: slot.name },
                }],
              },
            });

            map.addLayer({
              id: `text-${areaIndex}-${y}`,
              type: "symbol",
              source: `slot-text-${areaIndex}-${y}`,
              layout: {
                "text-field": ["get", "title"],
                "text-size": 16,
                "text-offset": [0, 0],
                "text-anchor": "top",
              },
              paint: {
                "text-color": "#fff",
                "text-halo-color": "#000",
                "text-halo-width": 3,
              },
            });
          });
        }
      });

      return () => map.remove();
    }, [propertyG, areaIndex]);

    return <div ref={mapRef} style={{ width: "100%", height: "500px", borderRadius: "10px" }} />;
  };

  // Update only privateDate
  function handleDateChange(areaIndex, slotIndex, value) {
    const updatedAreas = [...propertyG.area];
    const updatedSlots = [...updatedAreas[areaIndex].slots];

    updatedSlots[slotIndex] = {
      ...updatedSlots[slotIndex],
      privateDate: value
    };

    updatedAreas[areaIndex] = {
      ...updatedAreas[areaIndex],
      slots: updatedSlots
    };

    setPropertyData(prev => ({
      ...prev,
      area: updatedAreas
    }));
  }

  // Update only isPrivateEnable
  function handleToggle(areaIndex, slotIndex, checked) {
    const updatedAreas = [...propertyG.area];
    const updatedSlots = [...updatedAreas[areaIndex].slots];

    updatedSlots[slotIndex] = {
      ...updatedSlots[slotIndex],
      isPrivateEnable: checked
    };

    updatedAreas[areaIndex] = {
      ...updatedAreas[areaIndex],
      slots: updatedSlots
    };

    setPropertyData(prev => ({
      ...prev,
      area: updatedAreas
    }));
  }

  const videoId = propertyG && propertyG.videolink == null ? null : propertyG && propertyG.videolink ? getYouTubeVideoId(propertyG.videolink) : null;

  return (propertyG ?
    <div className="pro-detailsmain">
      <div className="add-formdiv-pro Property details_inner_section">
        <div className="add-main">
          <div className="add-formdiv">
            <div className="add-top">
              <div className="slot-datetable">
                <div className="slot-datetable1">
                  <h2>{propertyName}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="add-form">
          <div className="select-div">
            <div className="select-div1">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label required"
              >
                Property Name:
              </label>
              <input
                type="text"
                readOnly="true"
                value={propertyName}
                className="form-control"
                placeholder="Enter Property Name"
              />
            </div>
            <div className="select-div2">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label required"
              >
                Categary:
              </label>
              <input
                type="text"
                className="form-control"
                readOnly="true"
                value={propertyCategory}
                placeholder="Enter Categary"
              />
            </div>
          </div>

          <div className="select-div">
            <div className="select-div1">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label required"
              >
                Google Address:
              </label>
              <input
                type="text"
                className="form-control"
                readOnly="true"
                value={propertyG.areaaddress}
                placeholder="Enter Google Address"
              />
            </div>
            <div className="select-div2">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label required"
              >
                Country:
              </label>
              <input
                type="text"
                readOnly="true"
                value={propertyCounty}
                className="form-control"
                placeholder="Enter Country Name"
              />
            </div>
          </div>

          <div className="select-div">
            <div className="select-div1">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label required"
              >
                City:
              </label>
              <input
                type="text"
                readOnly="true"
                value={propertyCity}
                className="form-control"
                placeholder="Enter City Name"
              />
            </div>
            <div className="select-div2">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label required"
              >
                State:
              </label>
              <input
                type="text"
                className="form-control"
                readOnly="true"
                value={propertyState}
                placeholder="Enter State Name"
              />
            </div>
          </div>

          <div className="select-div">
            <div className="select-div1">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label required"
              >
                ZipCode:
              </label>
              <input
                type="text"
                className="form-control"
                readOnly="true"
                value={propertyZipCode}
                placeholder="Enter ZipCode"
              />
            </div>
            <div className="select-div2">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label required"
              >
                Total Property Area in Acres:
              </label>
              <input
                type="text"
                className="form-control"
                readOnly="true"
                value={propertyTotalArea}
                placeholder="Enter Total Property Area"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="pro-review-top">
        <div className="pro-review-ftop">
          <h1>Areas &amp; Slots</h1>
        </div>
      </div>

      {propertyG.area.map((area, index) => (
        <div className="add-formdiv mb-4" key={index}>
          <div className="slot-datetable">
            <div className="slot-datetable1 add-top">
              <h2>{area.areaname}</h2>
            </div>
          </div>

          <div className="add-form">
            <div className="areas&slot-div">
              <div className="areas&slot-buttion">
                {/* <button
                  className={area.isAreaUnit === `slotsonmap` ? "button1" : "button2"}
                  onClick={() => setActiveTab(index, 'slotsonmap')}
                >
                  Slots on Map
                </button> */}
                <button
                  className={area.isAreaUnit === `slotsdetails` ? "button1" : "button2"}
                  onClick={() => setActiveTab(index, 'slotsdetails')}
                >
                  Slots Details
                </button>
                <button
                  className={area.isAreaUnit === `availability` ? "button1" : "button2"}
                  onClick={() => setActiveTab(index, 'availability')}
                >
                  Availability
                </button>
              </div>
              {/* {area.isAreaUnit === 'slotsonmap' && (
                <AreaMap areaIndex={index} />
              )} */}

              {area.isAreaUnit === 'slotsdetails' && (
                <div className="slot-info-parent">
                  <div className="slots_details_dev">
                    <AreaMap areaIndex={index} />
                    <div className="add-table">
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col">Slot</th>
                            <th scope="col">Size in Acres</th>
                            <th scope="col">Private Slot</th>
                          </tr>
                        </thead>
                        <tbody>
                          {area.slots.map((slot, slotIndex) => (
                            <tr key={slotIndex}>
                              <td>{slot.name}</td>
                              <td>{slot.size} {slot.unit}</td>
                              <td className="private_field">
                                <input
                                  type="date"
                                  value={slot.privateDate || ""}
                                  onChange={(e) => handleDateChange(index, slotIndex, e.target.value)}
                                  style={{ cursor: "pointer", marginRight: "15px" }}
                                />
                                <label className="switch">
                                  <input
                                    type="checkbox"
                                    checked={slot.isPrivateEnable || false}
                                    onChange={(e) => handleToggle(index, slotIndex, e.target.checked)}
                                  />
                                  <span className="slider round"></span>
                                </label>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>


                  <button
                    type="button"
                    className="button_save_slots"
                    onClick={() => handleSlotsSave(area.slots, area._id, propertyG._id)}
                  >
                    Save
                  </button>
                </div>
              )}

              {area.isAreaUnit === 'availability' && (
                <div className="add-table">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">Start Date</th>
                        <th scope="col">End Date</th>
                        <th scope="col">Price($)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {area.dates.map((date, dateIndex) => (
                        <tr key={dateIndex}>
                          <td>
                            {convertdate(date.start)}
                          </td>
                          <td>
                            {convertdate(date.end)}
                          </td>
                          <td>{date.price}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}

      {(videoId || (propertyG && propertyG.images && propertyG.images.length > 0)) &&
        <div className="add-formdiv-media">
          <div className="slot-datetable">
            <div className="slot-datetable1 add-top">
              <h2>Property Media</h2>
            </div>
          </div>
          <div className="pro-imgdiv">
            {videoId &&
              <YouTubePlayer videoId={videoId} />
            }

            {propertyG.images.map((image, index) => (
              <div className="pro-imgdiv1" key={index}>
                <img src={process.env.REACT_APP_PROPERTY_IMAGE_BASEURL + '/' + image} alt="property" />
              </div>
            ))}
          </div>
        </div>
      }

      <div className="pro-btndiv">
        <button
          className="Reject"
          onClick={handleReject}
          disabled={propertyAction === 'Rejected'}>
          {propertyAction === 'Pending' ? 'Reject' : propertyAction === 'Rejected' ? 'Rejected' : 'Reject'}
        </button>

        <button
          className="Approve"
          disabled={propertyAction === 'Approved'}
          onClick={handleApprove}>
          {propertyAction === 'Pending' ? 'Approve' : propertyAction === 'Rejected' ? 'Approve' : 'Approved'}
        </button>
      </div>

      {rejectstatus && (
        <div className="managecou-popup">
          <div className="managecou-reject">
            <i className="fa-solid fa-xmark" onClick={handlepopupclose}></i>
            <div className="managecou-contentdiv">
              <img src={Xicon} alt="Xicon" />
              <h1>Are you Sure?</h1>
              <p>Are you sure you want to reject this property?</p>
              <textarea
                className="reject-reason"
                placeholder="Enter reason"
                id="floatingTextarea2"
                name="cancelreason"
                onChange={inputsHandler}
                value={step1inputField.cancelreason}
              ></textarea>
            </div>
            <div className="managecou-btn">
              <button className="btn1" onClick={handlepopupclose}>
                Cancel
              </button>
              <button className="btn2" onClick={handleRejectProperty}>
                Reject
              </button>
            </div>
          </div>
        </div>
      )}

      {approveStatus && (
        <div className="managecou-popup">
          <div className="managecou-content">
            <i className="fa-solid fa-xmark" onClick={handlepopupclose}></i>
            <div className="managecou-contentdiv">
              <img src={approveIcon} alt="approveIcon" />
              <h1>Are you Sure?</h1>
              <p>Are you sure you want to approve this property?</p>
            </div>
            <div className="managecou-btn">
              <button className="btn1" onClick={handlepopupclose}>
                Cancel
              </button>
              <button className="btnApprove2" onClick={handleApproveProperty}>
                Approve
              </button>
            </div>
          </div>
        </div>
      )}
    </div> : <div>{status}</div>
  );
}